export default __webpack_public_path__ + "static/media/Cambria.767a1ee4.ttf";